import React, { FC } from 'react'
import { Checkbox as CheckboxAnt, Form } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { UISizes, UITypes, i18n } from 'LibNeo'
import { GetFieldDecoratorOptions, WrappedFormUtils } from 'antd/lib/form/Form'
import { AutoTestsProps } from 'Types/autoTests'
import {
	CheckboxLabelDescription,
	CheckboxLabelIcon,
	CheckboxLabelWrapper,
	CheckboxWrapper,
} from '../styled'

interface CheckboxProps extends AutoTestsProps {
	fieldName?: string
	form?: WrappedFormUtils
	indeterminate?: boolean
	disabled?: boolean
	onChange?: (e: CheckboxChangeEvent) => void
	fieldOptions?: GetFieldDecoratorOptions
	checked?: boolean
	autoFocus?: boolean
	title?: string | JSX.Element
	className?: string
	tooltip?: string
	initialHeight?: boolean
	error?: boolean
	description?: string
	value?: string
}

export const CheckboxComponent: FC<CheckboxProps> = ({
	fieldName,
	disabled = false, // гарантирует появление атрибута data-qa-disabled, ввиду типа boolean | undef
	indeterminate,
	onChange,
	fieldOptions,
	checked,
	autoFocus,
	title,
	className,
	tooltip,
	form,
	initialHeight,
	dataQa,
	error,
	description,
	value,
}) => {
	const titleValue = typeof title === 'string' ? i18n(title) : title

	const checkedProps = form ? {} : { checked }

	const checkbox = (
		<CheckboxAnt
			autoFocus={autoFocus}
			disabled={disabled}
			onChange={onChange}
			indeterminate={indeterminate}
			{...checkedProps}
			data-qa-disabled={disabled}
			data-qa={dataQa}
			value={value}
		>
			<CheckboxLabelWrapper>
				{Boolean(title) && <span>{titleValue}</span>}
				{Boolean(tooltip) && (
					<CheckboxLabelIcon
						name="help"
						type={UITypes.PASSIVE}
						size={UISizes.SMALL}
						tooltip={tooltip}
					/>
				)}
				{Boolean(description) && <CheckboxLabelDescription>{description}</CheckboxLabelDescription>}
			</CheckboxLabelWrapper>
		</CheckboxAnt>
	)

	const getCheckbox = (): JSX.Element => {
		if (form) {
			return (
				<Form.Item>
					{form.getFieldDecorator(fieldName, {
						...fieldOptions,
						valuePropName: 'checked',
					})(checkbox)}
				</Form.Item>
			)
		}
		return checkbox
	}

	return (
		<CheckboxWrapper error={error} initialHeight={initialHeight} className={className}>
			{getCheckbox()}
		</CheckboxWrapper>
	)
}
